/** Helpers compartilhados da Chamada do professor (briefing / operação / resumo). */

import type { StatusPresencaAula } from '../../../types/models';

export function formatDateSafe(
  dateStr: string | null | undefined,
  format?: Intl.DateTimeFormatOptions,
): string {
  if (!dateStr) return '';
  try {
    const parts = dateStr.split('-');
    if (parts.length === 3) {
      const y = parseInt(parts[0], 10);
      const m = parseInt(parts[1], 10) - 1;
      const d = parseInt(parts[2], 10);
      const date = new Date(y, m, d, 12, 0, 0);
      if (!isNaN(date.getTime())) {
        return date.toLocaleDateString('pt-BR', format);
      }
    }
    const fallback = new Date(dateStr);
    if (!isNaN(fallback.getTime())) {
      return fallback.toLocaleDateString('pt-BR', format);
    }
  } catch (e) {
    console.error('Error formatting date:', e);
  }
  return '';
}

export function parseDateSafe(dateStr: string | null | undefined): Date {
  if (!dateStr) return new Date();
  try {
    const parts = dateStr.split('-');
    if (parts.length === 3) {
      const y = parseInt(parts[0], 10);
      const m = parseInt(parts[1], 10) - 1;
      const d = parseInt(parts[2], 10);
      const date = new Date(y, m, d, 12, 0, 0);
      if (!isNaN(date.getTime())) return date;
    }
    const fallback = new Date(dateStr);
    if (!isNaN(fallback.getTime())) return fallback;
  } catch (e) {
    console.error('Error parsing date:', e);
  }
  return new Date();
}

/** Extrai status já gravados (ex.: JUSTIFICADO por abono) do GET/POST da chamada. */
export function mapAlunosChamadaParaPresencas(
  chamada: {
    alunos?: Array<{
      alunoId?: string;
      aluno?: { id?: string };
      statusPresenca?: StatusPresencaAula;
    }>;
  } | null | undefined,
): Record<string, StatusPresencaAula> {
  const map: Record<string, StatusPresencaAula> = {};
  for (const ca of chamada?.alunos || []) {
    const id = ca.alunoId || ca.aluno?.id;
    if (id && ca.statusPresenca) map[id] = ca.statusPresenca;
  }
  return map;
}

export const DIA_LABELS: Record<string, string> = {
  SEGUNDA: 'Segunda-feira',
  TERCA: 'Terça-feira',
  QUARTA: 'Quarta-feira',
  QUINTA: 'Quinta-feira',
  SEXTA: 'Sexta-feira',
  SABADO: 'Sábado',
};
